<template>
	<div class="left_zs fl test">
		<!-- 项目概览 -->
		<div class="data-box1 left_tb fl" style="height: 30%;">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left fl">[</b>
				<span>场站状态</span>
				<b class="data-title-right fr">]</b>
			</div>
			<div id="PTechart" style="width: 100%;height:80%;"></div>
		</div>
		<div class="data-box1 left_tb fl" style="height: 25%;margin-top: 3%;">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left fl">[</b>
				<span>充电排行</span>
				<b class="data-title-right fr">]</b>
			</div>
			<Table class="centerTable" size="small" :columns="columns" :data="Data"></Table>
		</div>

		<!-- 一次通过率 -->
		<div class="data-box1 left_tb fl " style="height: 40%;margin-top: 4%;">
			<i class="topL"></i>
			<i class="topR"></i>
			<i class="bottomL"></i>
			<i class="bottomR"></i>
			<div class="data-title">
				<b class="data-title-left fl">[</b>
				<span>会员动态</span>
				<b class="data-title-right fr">]</b>
			</div>
			<div class="wenti_bg">
				<table size="small">
					<tbody class="numberDisplay3">
						<tr>
							<td>
								<p>会员总人数</p>
								<span style="color: #55557f;">{{OverviewTotal.TotalNum}}</span>
							</td>
							<td>
								<p>个人会员数</p>
								<span style="color: #ffaa7f;">{{OverviewTotal.PersonalNum}}</span>
							</td>
							<td>
								<p>集团会员数</p>
								<span style="color: #ff55ff;">{{OverviewTotal.GroupNum}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div id="charginEchart3" style="width: 95%;height: 70%;">
			</div>
		</div>
	</div>
</template>

<script>
	import echart from '../../../js/echarts_hot.js';
	import Qs from 'qs'
	import bus from './bus.js'
	import webapi from '../../../webapi.js';
	export default {
		props: [
			'batchSelectList',
			'deviceTypeSelectList'
		],

		data() {
			return {
				OverviewTotal: {
					TotalNum: 0,
					PersonalNum: 0,
					GroupNum: 0,
				},
				columns: [{
						title: '场站名称',
						key: 'StationName'
					}, {
						title: '充电次数',
						key: 'ChargeNum'
					}, {
						title: '充电电量',
						key: 'ChargeKwh'
					}
				],
				Data: [],
				pieMap1: {
					totalNum: 0,
					series: [{
							value: 2,
							name: "空闲",
							label: {
							        alignTo: 'edge',
							        formatter: '{name|{b}}\n{time|{c} 小时}',
							        minMargin: 5,
							        edgeDistance: 10,
							        lineHeight: 15,
							        rich: {
							          time: {
							            fontSize: 10,
							            color: '#999'
							          }
							        }
							      },
						}, {
							value: 3,
							name: "充电"
						},
						{
							value: 5,
							name: "离线"
						},
						{
							value: 1,
							name: "故障"
						}
					],
					legend_data: ["空闲", "充电", "离线", "故障"]
				},
				//会员概况图表数据
				lineEchart: {
					legend_data: ['新增人数'],
					seriesData: [{
						name: '新增人数',
						type: 'line',
						stack: '分量',
						data: [0, 0, 0, 0, 0, 0, 0]
					}],
					style: {
						color: "#00ff7f"
					},
					TimePoins: [1, 2, 3, 4, 5, 6, 7]
				},
				timer: null,
			}
		},
		components: {
		},
		computed: {
		},
		mounted() {
			//会员概览
			this.GetOverviewMember();
			//充电排行
			this.GetChargeRanking();
			window.addEventListener('resize', function() {
				echart.resizeEchart();
			})
			this.timer = setInterval(() => {
				this.GetOverviewMember();
				this.GetChargeRanking()
			}, 60000);
		},
		created() {
			const _this = this
			bus.$on("pieSeries", function(params) {
				_this.pieMap1.series = params.pieSeries
				_this.pieMap1.totalNum = params.totalNum
				echart.disposeEchart("PTechart")
				echart.initPiechart("PTechart", _this.pieMap1, _this);
			});
		},
		destroyed() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		},
		activated() {},
		deactivated() {},
		watch: {
		},
		methods: {
			//初始化饼图
			initPie: function() {
				echart.initPiechart("PTechart", this.pieMap1, this);
			},
			//中间充电排行
			GetChargeRanking: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/GetChargeRanking", ).then(res => {
					if (res.data.code != 1) {
						console.log("中间充电排行");
						console.log(res.data);
						_this.Data = res.data.Data.List
					}
				})
			},

			//会员概览
			GetOverviewMember: function() {
				const _this = this;
				this.$axios.post(webapi.base_api_url + '/Overview/GetOverviewMember', {}).then(res => {
						console.log("会员概览");
						console.log(res.data.Data);
						_this.OverviewTotal.TotalNum = res.data.Data.TotalNum;
						_this.OverviewTotal.PersonalNum = res.data.Data.PersonalNum;
						_this.OverviewTotal.GroupNum = res.data.Data.GroupNum;
						_this.lineEchart.TimePoins = res.data.Data.Curves.TimePoints;
						_this.lineEchart.seriesData[0].data = res.data.Data.Curves.NewlyCount;
						echart.initLinechart2("charginEchart3", _this.lineEchart)
					})
					.catch(function(err) {
						console.log(err);
						echart.initLinechart2("charginEchart3", _this.lineEchart)
					});
			},
		}
	}
</script>

<style>
	.test {
		transition: all 2s;
	}

	.numberDisplay3 p {
		display: block;
		border-left: 4px solid green;
		padding-left: 2px;

	}

	.numberDisplay3 td {
		width: 33%;
	}

	.numberDisplay3 span {
		font-size: 30px;
		color: greenyellow;
		text-align: center;
		display: block;
	}
</style>
